// removed by extract-text-webpack-plugin
module.exports = {"NotFound":"NotFound__NotFound__31Cli","NotFoundBox":"NotFound__NotFoundBox__godlx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFound/NotFound.css
// module id = 786
// module chunks = 0